// src/audio/clicks.js
const CLICK_URL = process.env.PUBLIC_URL + '/click_input_750hz.wav';

// Preload a base Audio object
const base = new Audio(CLICK_URL);
base.preload = 'auto';
base.volume = 0.6;

// Warmup must be called once after a user gesture to satisfy autoplay policies
export function warmupAudio() {
  // Try a silent play/pause to unlock audio
  base.volume = 0.001;
  base.play().then(() => base.pause()).catch(() => {});
  base.volume = 0.6;
}

// Play using a clone so overlapping clicks don’t cut off
export function playClick() {
  const a = base.cloneNode(); // HTMLAudioElement
  a.volume = base.volume;
  a.play().catch(() => {});
}
